import '../../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FILE_BLUE } from '../../appearance/Colors';

const ERROR_LABELS = {
    invalid_scope: 'The configured X scopes are invalid for this app.',
    unauthorized_client: 'The X app credentials are invalid or missing required auth setup.',
    access_denied: 'Access was denied during X authorization.',
    invalid_callback: 'OAuth callback is missing required state or code.',
    token_exchange_failed: 'Failed to exchange authorization code for tokens.',
    feature_disabled: 'X integration is disabled for this account.',
    server_misconfigured: 'Server configuration for X integration is incomplete.'
};

const readError = (search) => {
    const params = new URLSearchParams(search);
    const code = params.get('x_oauth_error') || 'unknown_error';
    const description = params.get('x_oauth_error_description') || '';
    return {
        code,
        description
    };
};

function XOAuthErrorPage() {
    const {t: lnT} = useTranslation();

    const history = useHistory();
    const location = useLocation();
    const { code, description } = readError(location.search);
    const headline = ERROR_LABELS[code] || lnT('common:xAuthorizationFailed');

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                backgroundColor: '#f7f9fc'
            }}
        >
            <div
                style={{
                    maxWidth: 620,
                    width: '100%',
                    backgroundColor: '#fff',
                    border: '1px solid #e8edf3',
                    borderRadius: 12,
                    padding: 24
                }}
            >
                <h2 style={{ marginTop: 0, marginBottom: 12, color: '#1f2937' }}>{lnT('auth:xConnectionFailed')}</h2>
                <p style={{ margin: 0, color: '#374151', lineHeight: 1.45 }}>{headline}</p>
                {description ? (
                    <p style={{ marginTop: 12, color: '#4b5563', lineHeight: 1.45 }}>{lnT('auth:details')}{description}
                    </p>
                ) : null}
                <p style={{ marginTop: 12, color: '#6b7280', fontSize: 13 }}>{lnT('auth:errorCode')}<code>{code}</code>
                </p>

                <div style={{ display: 'flex', gap: 14, marginTop: 20 }}>
                    <button
                        onClick={() => history.push('/')}
                        style={{
                            border: 'none',
                            backgroundColor: FILE_BLUE,
                            color: '#fff',
                            padding: '10px 16px',
                            borderRadius: 8,
                            cursor: 'pointer',
                            fontWeight: 600
                        }}
                    >{lnT('auth:goToApp')}</button>
                    <button
                        onClick={() => history.push('/tools/integrations')}
                        style={{
                            border: '1px solid #d1d5db',
                            backgroundColor: '#fff',
                            color: '#111827',
                            padding: '10px 16px',
                            borderRadius: 8,
                            cursor: 'pointer',
                            fontWeight: 600
                        }}
                    >{lnT('auth:openIntegrations')}</button>
                </div>
            </div>
        </div>
    );
}

export default XOAuthErrorPage;
